import React from "react";
import "../../../../SCSS/setup.scss";
import "../../../../SCSS/services.scss";
// import Loader from "../../../../../utils/loader/loaders";
import Axios from "axios";
import KenTable from "../../../../global_components/KenTable/kentable";
import { withRouter } from "react-router-dom";
import KenPaginationUI from "../../../../global_components/KenPaginator";
// import employeeForm from "./leaves.json";
import LeavePolicy from "./leavepolicy.json";
import KenForm from "../../../../global_components/KenForm/zqform";
import RestoreOutlinedIcon from "@material-ui/icons/RestoreOutlined";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import { Alert } from "rsuite";
import moment from "moment";
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import ZqHistory from "../../../../../gigaLayout/change-history";
// import zq_api from "../../../../../utils/api-service";
import { Drawer } from "rsuite";
import Snackbar from '@material-ui/core/Snackbar';
class Leaves extends React.Component {
  constructor(props) {
    super(props);
    // this.zq_api = new zq_api();
    this.state = {
      printTime: "",
      employeeDetails: [],
      useremail: localStorage.getItem("email"),
      phone: localStorage.getItem("phone"),
      channel: localStorage.getItem("channel"),
      env: JSON.parse(localStorage.getItem("env")),
      authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
      userId: localStorage.getItem("userId"),
      orgId: "606ac70479dbb25447375fa8",
      orgName: localStorage.getItem("orgName"),
      username: localStorage.getItem("username"),
      noProg: "Fetching Details..",
      leavePolicyData: LeavePolicy,
      loader: false,
      page: 1,
      limit: 10,
      totalRecord: 0,
      totalPages: 1,
      tabview: true,
      employeeFormData: [],
      employeeName: "",
      Employee: "",
      history: false,
      showHistory: false,
      historyData: [],
      globalSearch: false,
      entityInstanceId: undefined,
      preview: false,
      leaveType: "",
      containerNav: {
        isBack: false,
        name: "List of Leave Policies",
        isName: true,
        total: 0,
        isTotalCount: false,
        isSearch: false,
        isSort: false,
        isPrint: true,
        isDownload: false,
        isShare: false,
        isNew: true,
        newName: "New",
        isSubmit: false,
      },
      apiCall: false,
      snackBar: false,
      leaveId: "",
      addLeaveId: "",
    };
  }

  componentDidMount() {
    this.getLeaves();
  }

  getLeaves = () => {
    this.setState({ loader: true })
    var headers = {
      'Authorization': this.state.authToken
    }
    Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/designation?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}`, { headers: headers })
      .then(res => {
        if (res.data.status == 'success') {
          let data = res.data.data
          this.setState({ desingationTotal: data.length }, () => {
            Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/leavepolicy?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}`, { headers: headers })
              .then(res => {
                console.log(res.data.data, "leavepolicy")
                if (res.data.status == 'success') {
                  let tabData = [];
                  let jobTypeData = [];
                  let employeeTypeData = [];
                  let genderData = [];
                  let carryForwardData = [];
                  let data = res.data.data;
                  if (data.length > 0) {

                    data.map(item => {
                      let createdBy = "-"
                      if (item.createdPersonInfo.length > 0) {
                        createdBy = (String(item.createdPersonInfo[0].salutation).length > 1 ? (item.createdPersonInfo[0].salutation + ".") : "") + item.createdPersonInfo[0].firstName + " " + (item.createdPersonInfo[0].lastName != null ? String(item.createdPersonInfo[0].lastName).replace("-", "") : "")
                      }
                      tabData.push({
                        "ID": item.id,
                        "Leave Type": item.leaveType,
                        "Designation": item.designationReferenceId != undefined ? item.designationReferenceId.length > 0 ? item.designationReferenceId[0].designation : "-" : "-",
                        "Max. No. of Leaves per Month": item.maxLeavesPerMonth,
                        "Max. No. of Leaves per Year": item.maxLeavesPerYear,
                        "Created By": createdBy,
                        "Version": String('V' + Number(item.__v + 1)),
                        "Status": item.status,
                        'Item': JSON.stringify(item)
                      })
                      if (item.jobType) {
                        jobTypeData.push({
                          label: item.jobType,
                          value: item.jobType
                        })
                      }
                      if (item.jobType) {
                        employeeTypeData.push({
                          label: item.jobType,
                          value: item.jobType
                        })
                      }
                      if (item.gender) {
                        genderData.push({
                          label: item.gender,
                          value: item.gender
                        })
                      }
                      if (item.carryForward) {
                        carryForwardData.push({
                          label: item.carryForward,
                          value: item.carryForward
                        })
                      }

                    })
                    // let filterJobTypeDetails = Array.from(new Set(jobTypeData.map(JSON.stringify))).map(JSON.parse)
                    // let genderFilteredData = Array.from(new Set(genderData.map(JSON.stringify))).map(JSON.parse)
                    // let carryForwardFilteredData = Array.from(new Set(carryForwardData.map(JSON.stringify))).map(JSON.parse)
                    // employeeForm['General'].map(item => {
                    //   if (item.name == 'jobType') {
                    //     item.options = filterJobTypeDetails
                    //   }
                    // })
                    // employeeForm['Eligibility'].map(item => {
                    //   if (item.name == 'employee type') {
                    //     item.options = filterJobTypeDetails
                    //   }
                    //   if (item.name == 'gender') {
                    //     item.options = genderFilteredData
                    //   }
                    //   if (item.name == 'carry Forward') {
                    //     item.options = carryForwardFilteredData
                    //   }
                    // })
                    this.setState({
                      loader: false,
                      employeeDetails: tabData,
                      noProg: '',
                      page: res.data.currentPage,
                      limit: res.data.perPage,
                      totalRecord: res.data.totalRecord,
                      totalPages: res.data.totalPages
                    });
                  } else if (data.length == 0) {
                    this.setState({ employeeDetails: [], noProg: 'No Data' });
                  }
                }
              }).catch(err => {
                this.setState({ employeeDetails: [], loader: false, noProg: 'No Data' });
              })
          })
        }
      })
  }


  onSubmit = (data, item) => {
    console.log("dataitem", data, item)

    let userData = this.state.leavePolicyData;
    let apiNewCall = true;
    userData.map(item => {
      if (item.requiredBoolean) {
        if (item['defaultValue'] === "" || item['defaultValue'] === undefined || item['error'] || item['defaultValue'] == null) {
          item["error"] = true;
          item["validation"] = true
          item['errorMsg'] = `Invalid ${item.label}`
          apiNewCall = false
        } else {
          item["error"] = false;
          item["validation"] = false;
        }
      }
    })
    this.setState({ leavePolicyData: userData }, () => {
      if (apiNewCall) {
        this.setState({ loader: true }, () => {
          let payloadInput = {}
          this.state.leavePolicyData.map(item => {
            if (item.type != "heading" && item.category != "button") {
              payloadInput[item.name] = item.defaultValue
            }
          })
          let payload = {
            "id": String(payloadInput.id),
            "leaveType": payloadInput.leaveType,
            "maxLeavesPerMonth": payloadInput.maxPerMonth,
            "maxLeavesPerYear": payloadInput.maxPerYear,
            "designationReferenceId": payloadInput.desigType,
            "createdBy": this.state.userId,
            "updatedBy": this.state.userId,
            "status": "Active",
          }
          console.log("payloadInput", payload)
          var headers = {
            'Authorization': this.state.authToken
          }
          if (!this.state.apiCall) {
            Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/leavepolicy`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getLeaves();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                      })
                    }, 2000)
                  })
                });
              })
          }
          else {
            Axios.put(`https://api.zenqore.com/payroll/uat/hkbk/masters/leavepolicy?id=${this.state.entityInstanceId}`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getLeaves();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                      })
                    }, 2000)
                  })
                });
              })
          }
        })

      }


    })

  }

  getDepartment = (preview, item) => {
    this.setState({ loader: true }, () => {
      let config = {
        headers: {
          "Authorization": this.state.authToken,
          'Content-Type': 'application/json'
        }
      }
      Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/designation?org=${this.state.orgId}`, config)
        .then(resDept => {
          console.log(resDept.data.data)
          if (resDept.data.status == 'success') {
            let employeeOptions = []
            resDept.data.data.map(item => {

              employeeOptions.push({
                label: item.designation,
                value: item._id
              })
            })
            let leavePolicyData = this.state;
            this.setState({ leavePolicyData: LeavePolicy }, () => {
              LeavePolicy.map((item) => {
                if (item.name == "desigType") {
                  item.options = employeeOptions
                  // item['defaultValue'] = details.shift
                  item["error"] = false;
                  item["required"] = item.requiredBoolean
                  item["validation"] = false
                }
                else {
                  item.defaultValue = item.defaultValue
                }
              })
              if (preview) {
                let leavePolicyData = this.state.leavePolicyData;
                let details = JSON.parse(item.Item)
                let objKeys = Object.keys(details);
                let entityInstanceId = details["_id"];
                let leaveId = details.id;
                console.log("details", details);

                this.setState({ tabview: false, preview: true, apiCall: true, entityInstanceId: entityInstanceId, leaveId });
                objKeys.map((key) => {
                  leavePolicyData.map((item) => {
                    // let keyName = key.toLowerCase().replace(/ /g, "");
                    // let name = String(details['Department Head']).split()
                    if (item.name == "id") {
                      item["defaultValue"] = details['id'];
                      item["readOnly"] = false;
                      item["required"] = false;
                    }
                    else if (item.name == "leaveType") {
                      item["defaultValue"] = details['leaveType'];
                      item["readOnly"] = false;
                      item["required"] = false;
                    }
                    else if (item.name == "desigType") {
                      item["defaultValue"] = details.designationReferenceId != undefined ? details.designationReferenceId.length > 0 ? details.designationReferenceId[0]["_id"] : null : null;
                      item["readOnly"] = false;
                      item["required"] = false;
                    }
                    else if (item.name == "maxPerMonth") {
                      item["defaultValue"] = details['maxLeavesPerMonth'];
                      item["readOnly"] = false;
                      item["required"] = false;
                    }
                    else if (item.name == "maxPerYear") {
                      item["defaultValue"] = details['maxLeavesPerYear'];
                      item["readOnly"] = false;
                      item["required"] = false;
                    }

                  })
                })
                this.setState({ leavePolicyData });
              }
              this.setState({ tabview: false, preview: false, loader: false });
            });
          }
        }).catch(err => {
          console.log("err", err)
        })
    })


  }

  onInputChanges = (value, item, e, dataS) => {
    console.log("value", value)
    console.log("item", item)
    console.log("e", e)
    console.log("dataS", dataS)
    if (dataS != undefined) {
      if (dataS["name"] === "type") {
        dataS["defaultValue"] = value;

      }
    }
    else {
      item["defaultValue"] = value
    }

  }


  onPreviewLeaves = (item) => {
    this.getDepartment(true, item);

  };

  // componentWillMount() {
  //   this.setState({ employeeFormData: employeeForm }, () => {
  //     console.log("globalsearch", this.props);
  //     if (this.props.location.data != undefined) {
  //       this.setState({ globalSearch: true }, () => {
  //         this.onPreviewLeaves(this.props.location.data);
  //       });
  //     }
  //   });
  // }

  resetform = () => {
    let leavePolicyData = this.state.leavePolicyData;
    leavePolicyData.map((item) => {
      item["defaultValue"] = undefined;
      item["readOnly"] = false;
      item["error"] = false;
      item["required"] = item.requiredBoolean
      item["validation"] = false
    });
    this.setState(leavePolicyData);
  };

  getTime = () => {
    setInterval(() => {
      this.setState({
        printTime: moment(new Date())
          .format("DD/MM/YYYY (hh:mm:ss A)")
          .toLocaleString(),
      });
    }, 1000);
  };
  showHistory = () => {
    this.setState({ history: true, showHistory: true });
  };
  onCloseForm = () => {
    this.setState({ showHistory: false });
  };

  getBranchList = () => {
    let apiDetails = {
      url: `${this.state.env["zqBaseUri"]}/master/get/branches?org=${this.state.orgId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.state.authToken,
      },
    };
    this.zq_api.get(apiDetails).then((response) => {
      console.log("Get Branch List API", response);
      let apiData = response.data;
      let branchList = [];
      apiData.forEach((item) => {
        let branchObj = {};
        branchObj.label = item["branchDetails"].branchName;
        branchObj.value = item._id;
        branchList.push(branchObj);
      });
      let formData = this.state.employeeFormData;
      formData["CTC Details"].map((item) => {
        if (item.name === "selectbranch") {
          item["options"] = branchList;
        }
      });
      this.setState({ branchList: branchList, apiData: apiData });
    });
  };
  getEmployees1 = () => {
    this.setState({ loader: true });
    // Axios.get(`${this.state.env['zqBaseUri']}/master/get/employees?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}&pagination=true`, { headers: { 'Authorization': this.state.authToken } })
    let apiDetails = {
      url: `${this.state.env["zqBaseUri"]}/master/get/employee?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}&pagination=false`,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.state.authToken,
      },
    };
    this.zq_api
      .get(apiDetails)
      .then((res) => {
        if (res.failed == undefined) {
          console.log("Emp List", res);
          var api_data = res.data;
          // let currentPage = res.page
          // let nextPage = res.next_page
          // let limit = res.perPage
          // let total = res.total
          // let totalPages = res.total_pages
          // this.setState({ totalPages: totalPages, totalRecord: total, limit })
          var employeeData = [];
          if (api_data.length === 0) {
            this.setState({ loader: false });
            this.setState({ noProg: "No Data" });
          } else {
            api_data.map((item) => {
              var modifiedDate = new Date(
                Number(item["updatedAt"])
              ).toLocaleDateString();
              console.log("modifiedDate", modifiedDate);
              employeeData.push({
                ID: item["employeeId"],
                Name: item["firstName"] + " " + item["lastName"],
                Email: item["email"],
                // "Type":String(item['type'])=='null'?'NA':item['type'],
                CTC: item["CTC"] ? item["CTC"] : "-",
                "Bank Account No.": item["bankAccountNumber"]
                  ? item["bankAccountNumber"]
                  : "-",
                "PF Account No.": item["PFAccountNumber"]
                  ? item["PFAccountNumber"]
                  : "-",
                "ESI Account No.": item["ESIAccountNumber"]
                  ? item["ESIAccountNumber"]
                  : "-",
                "Contact No.": item["phoneNumber1"],
                Version: "V" + item["version"],
                "Modified Date": item["updatedAt"] ? modifiedDate : "-",
                Status:
                  String(item["status"]) == "undefined" ? "NA" : item["status"],
                Item: JSON.stringify(item),
              });
            });
            this.setState({ employeeDetails1: employeeData });
            this.setState({ loader: false });
          }
        } else {
          this.setState({ loader: false, noProg: "No Data" });
        }
      })

      .catch((err) => {
        this.setState({ branchDetails: [], noProg: "No Data" });
        this.setState({ loader: false });
      });
  };
  getChangeHistory = (entityInstanceId) => {
    Axios.get(
      `${this.state.env["zqBaseUri"]}/master/changeHistory/getChangeHistory?org=${this.state.orgId}&entity=employee&entityInstanceId=${entityInstanceId}`
    )
      .then((response) => {
        let api_data = response.data;
        let historyData = [];
        api_data.sort((data1, data2) => {
          return Number(data2.created_at) - Number(data1.created_at);
        });
        api_data.map((item) => {
          let date = new Date(
            new Intl.DateTimeFormat("en-US", {
              month: "2-digit",
              day: "numeric",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            }).format(item["created_at"])
          );
          let descriptionData = item.description["0"]
            .split(",")
            .map((desc, i) => {
              return (
                <p key={i}>
                  <div style={{ display: "flex" }}>
                    <span className="span-hist" style={{ width: "5%" }}>
                      -
                    </span>
                    {desc}
                  </div>
                </p>
              );
            });
          historyData.push({
            description: descriptionData,
            time: moment(date).format("hh:mm"),
            created_at: item["created_at"]
              ? moment(date).format("DD/MM/YYYY (hh:mm A)")
              : "-",
            version: item.version,
            btn: false,
          });
        });
        this.setState({ historyData: historyData });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onPaginationChange = (page, limit) => {
    this.setState({ page: page, limit: limit }, () => {
      this.getLeaves();
    });
  };
  onPreviewLeaves1 = (item) => {
    // this.setState({ leaveID: (" | " + item["Leave Type"] + " | " + item["ID"]), leaveType: item["Leave Type"] })
    this.setState({ leaveID: (" | " + 'Leave Policy' + " | " + item["ID"]), leaveType: 'Leave Policy' })

    let employeeFormData = this.state.employeeFormData;
    let details = JSON.parse(item.Item)
    console.log(details, "details")
    let objKeys = Object.keys(details);
    let entityInstanceId = details["_id"];
    this.setState({
      employeeName: item["Name"],
      idosId: details["idos_id"],
      entityInstanceId: entityInstanceId,
    });
    this.setState({ tabview: false, preview: true });

    objKeys.map((key) => {
      Object.keys(employeeFormData).forEach((dataKey) => {
        employeeFormData[dataKey].map((item) => {
          let itemName = item.name != undefined ? item.name.toLowerCase().replace(/ /g, "") : "";
          let keyName = key.toLowerCase().replace(/ /g, "");
          console.log(itemName, "itemName")
          if (keyName == itemName) {
            console.log(details[key], "details key")
            item["defaultValue"] = details[key];
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'jobType') {
            item["defaultValue"] = details.jobType;
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'designation') {
            item["defaultValue"] = "All";
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'annualtotal') {
            item["defaultValue"] = 12;
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'description') {
            item["defaultValue"] = "-";
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'isApprovalRequired') {
            item["defaultValue"] = details.isApprovalRequired == 'Yes' ? true : false;
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'employeetype') {
            item["defaultValue"] = details.jobType
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'gender') {
            item["defaultValue"] = details.gender
            item["readOnly"] = false;
            item["required"] = false;
          }
          if (itemName == 'carryForward') {
            item["defaultValue"] = details.carryForward
            item["readOnly"] = false;
            item["required"] = false;
          }

        });
        // console.log(employeeForm, "employeeforem")
      });
    });
    this.getChangeHistory(entityInstanceId);
  };
  handleBack = () => {
    this.resetform();
    if (this.props.location.status != "active") {
      this.resetform();
      this.setState({ tabview: true });
    } else {
      this.props.history.goBack();
    }
  };

  onAddEmployees = () => {

    this.setState({ apiCall: false }, () => {
      this.resetform()

      let leavePolicyData = this.state.leavePolicyData;
      this.setState({ loader: true }, () => {
        var headers = {
          'Authorization': this.state.authToken
        }
        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/payroll/generateNextId?type=LEAVE&collection=leavepolicies`, { headers: headers })
          .then(res => {
            console.log(res.data.data)
            this.getDepartment(false, undefined);
            let addLeaveId = res.data.data;
            leavePolicyData.map((item) => {
              if (item.name == 'id') {
                item["defaultValue"] = res.data.data;
                item["readOnly"] = true;
                item["error"] = false;
                item["required"] = item.requiredBoolean
                item["validation"] = false
              }
            });

            this.setState({ leavePolicyData: leavePolicyData, addLeaveId }, () => {
              this.getDepartment(false, undefined);
            });

          }).catch(err => {
            this.setState({
              loader: false
            });
          })
      });


    })
  };

  formBtnHandle = (item) => {
    return item === "clear" ? this.cleartabData() : this.canceltabData();
  };
  cleartabData = () => {
    this.resetform();
  };
  canceltabData = () => {
    this.resetform();
    this.setState({ tabview: true });
  };
  handleTabChange = (tabName, formDatas) => {
    console.log(tabName);
    console.log(formDatas);
  };
  resetform1 = () => {
    let employeeFormData = this.state.employeeFormData;
    Object.keys(employeeFormData).forEach((tab) => {
      employeeFormData[tab].forEach((task) => {
        delete task["defaultValue"];
        task["readOnly"] = false;
        task["error"] = false;
        task["required"] = task["requiredBoolean"];
        task["validation"] = false;
      });
    });
    this.setState({ employeeFormData });
  };
  onFormSubmit1 = (data, item) => {
    console.log(data, item);
    this.setState({ loader: true });
    let contactData = data["Contact Details"];
    let bankData = data["Bank Details"];
    let ctcData = data["CTC Details"];
    let defaultValue1 = {};
    contactData.map((item) => {
      if (item["name"] == "firstname") {
        defaultValue1["FirstName"] = item["defaultValue"];
      }
      if (item["name"] == "lastname") {
        defaultValue1["LastName"] = item["defaultValue"];
      }
      if (item["name"] == "employeeid") {
        defaultValue1["EmployeeId"] = item["defaultValue"];
      }
      if (item["name"] == "email") {
        defaultValue1["EmailAddress"] = item["defaultValue"];
      }
      if (item["name"] == "phonenumber1") {
        defaultValue1["Phonenumber1"] = item["defaultValue"];
      }
      if (item["name"] == "phonenumber2") {
        defaultValue1["Phonenumber2"] = item["defaultValue"];
      }
      if (item["name"] == "aadhaar") {
        defaultValue1["Aadhar"] = item["defaultValue"];
      }
      if (item["name"] == "pan") {
        defaultValue1["PAN"] = item["defaultValue"];
      }
    });
    bankData.map((item) => {
      if (item["name"] == "bankname") {
        defaultValue1["BankName"] = item["defaultValue"];
      }
      if (item["name"] == "bankaccountname") {
        defaultValue1["BankAccountName"] = item["defaultValue"];
      }
      if (item["name"] == "bankaccountnumber") {
        defaultValue1["BankAccountNo."] = item["defaultValue"];
      }
      if (item["name"] == "bankifsc") {
        defaultValue1["BankIFSC"] = item["defaultValue"];
      }
    });
    ctcData.map((item) => {
      if (item["name"] == "selectbranch") {
        defaultValue1["BranchId"] = item["defaultValue"];
      }
      if (item["name"] == "typeofemployment") {
        defaultValue1["EmployeeType"] = item["defaultValue"];
      }
      if (item["name"] == "ctc") {
        defaultValue1["CTC"] = item["defaultValue"];
      }
      if (item["name"] == "esiaccountnumber") {
        defaultValue1["ESIAccountNumber"] = item["defaultValue"];
      }
      if (item["name"] == "pfaccountnumber") {
        defaultValue1["PFAccountNumber"] = item["defaultValue"];
      }
      if (item["name"] == "UAN") {
        defaultValue1["UAN"] = item["defaultValue"];
      }
      if (item["name"] == "ESIIP") {
        defaultValue1["ESIIP"] = item["defaultValue"];
      }
    });
    console.log("defaultValue1", defaultValue1);
    if (this.state.preview !== true) {
      let payload = {
        email: defaultValue1["EmailAddress"],
        firstName: defaultValue1["FirstName"],
        lastName: defaultValue1["LastName"],
        phoneNumber1: Number(defaultValue1["Phonenumber1"]),
        phoneNumber2: defaultValue1["Phonenumber2"]
          ? Number(defaultValue1["Phonenumber2"])
          : null,
        aadhaar: defaultValue1["Aadhar"],
        PAN: defaultValue1["PAN"].toUpperCase(),
        CTC: Number(defaultValue1["CTC"]),
        branchId: defaultValue1["BranchId"],
        bankName: defaultValue1["BankAccountName"],
        status: "Active",
        bankAccountName: defaultValue1["BankAccountName"],
        bankAccountNumber: Number(defaultValue1["BankAccountNo."]),
        bankIFSC: defaultValue1["BankIFSC"].toUpperCase(),
        typeOfEmployment: this.state.Employee,
        PFAccountNumber: Number(defaultValue1["PFAccountNumber"]),
        ESIAccountNumber: Number(defaultValue1["ESIAccountNumber"]),
        orgEmailId: this.state.useremail,
        UAN: defaultValue1["UAN"],
        employeeId: defaultValue1["EmployeeId"],
        orgId: this.state.orgId,
        userId: this.state.channel,
        ESIIP: Number(defaultValue1["ESIIP"]),
      };
      // fetch(`${this.state.env['zqBaseUri']}/master/add/employee`, {
      //     method: 'POST', body: JSON.stringify(payload),
      //     headers: {
      //         "Authorization": this.state.authToken,
      //         'Content-Type': 'application/json'
      //     }
      // }).then(res => {
      //     res.json().then(response => {
      //         this.getEmployees();
      //         this.setState({ tabview: true })
      //     })
      // })
      //     .catch(err => {
      //         Alert.error('Something went wrong. Please Try again');
      //     })
      let apiDetails = {
        url: `${this.state.env["zqBaseUri"]}/master/add/employee`,
        headers: {
          "Content-Type": "application/json",
        },
        payload: payload,
      };
      this.zq_api.post(apiDetails).then((res) => {
        if (res.failed == undefined) {
          setTimeout(() => {
            Alert.success(res.message);
            this.getEmployees();
          }, 1000);
          this.resetform();
          this.setState({ tabview: true });
          this.setState({ loader: false });
        } else {
          Alert.error(res.error.response.data.message);
          this.getEmployees();
          this.setState({ loader: false, tabview: true });
        }
      });
    } else {
      let payload = {
        email: defaultValue1["EmailAddress"],
        firstName: defaultValue1["FirstName"],
        lastName: defaultValue1["LastName"],
        phoneNumber1: Number(defaultValue1["Phonenumber1"]),
        phoneNumber2: defaultValue1["Phonenumber2"]
          ? Number(defaultValue1["Phonenumber2"])
          : null,
        aadhaar: defaultValue1["Aadhar"],
        PAN: defaultValue1["PAN"].toUpperCase(),
        CTC: Number(defaultValue1["CTC"]),
        branchId: defaultValue1["BranchId"],
        bankName: defaultValue1["BankAccountName"],
        status: "Active",
        bankAccountName: defaultValue1["BankAccountName"],
        bankAccountNumber: Number(defaultValue1["BankAccountNo."]),
        bankIFSC: defaultValue1["BankIFSC"].toUpperCase(),
        typeOfEmployment: defaultValue1["EmployeeType"],
        PFAccountNumber: Number(defaultValue1["PFAccountNumber"]),
        ESIAccountNumber: Number(defaultValue1["ESIAccountNumber"]),
        orgEmailId: this.state.useremail,
        UAN: defaultValue1["UAN"],
        employeeId: defaultValue1["EmployeeId"],
        orgId: this.state.orgId,
        userId: this.state.channel,
        ESIIP: Number(defaultValue1["ESIIP"]),
        _id: this.state.entityInstanceId,
      };
      // fetch(`${this.state.env['zqBaseUri']}/master/update/employee`, {
      //     method: 'PUT', body: JSON.stringify(payload),
      //     headers: {
      //         "Authorization": this.state.authToken,
      //         'Content-Type': 'application/json'
      //     }
      // }).then(res => {
      //     res.json().then(response => {
      //         this.getEmployees();
      //         this.setState({ tabview: true })
      //     })
      // })
      //     .catch(err => {
      //         Alert.error('Something went wrong. Please Try again');
      //     })
      let apiDetails = {
        url: `${this.state.env["zqBaseUri"]}/master/update/employee`,
        headers: {
          "Content-Type": "application/json",
        },
        payload: payload,
      };
      this.zq_api.put(apiDetails).then((res) => {
        if (res.failed == undefined) {
          setTimeout(() => {
            this.getEmployees();
          }, 1000);

          this.resetform();
          this.setState({ tabview: true });
          this.setState({ loader: false });
        } else {
          this.resetform();
          Alert.error("Something went wrong. Please Try again");
          this.setState({ loader: false });
          this.setState({ tabview: true });
          setTimeout(() => {
            this.getEmployees();
          }, 1000);
        }
      });
    }
  };
  onInputChanges1 = (value, item, e, dataS) => {
    var employeeFormData = this.state.employeeFormData;
    if (dataS != undefined) {
      if (dataS.name == "typeofemployment") {
        console.log(this.state.employeeFormData);
        this.setState({ Employee: value });
        if (value == "consultant") {
          employeeFormData["CTC Details"]["3"]["label"] = "PF Account No";
          employeeFormData["CTC Details"]["3"]["requiredBoolean"] = false;
          employeeFormData["CTC Details"]["4"]["label"] = "UAN";
          employeeFormData["CTC Details"]["4"]["requiredBoolean"] = false;
        } else {
          employeeFormData["CTC Details"]["3"]["label"] = "PF Account No";
          employeeFormData["CTC Details"]["3"]["requiredBoolean"] = false;
          employeeFormData["CTC Details"]["4"]["label"] = "UAN";
          employeeFormData["CTC Details"]["4"]["requiredBoolean"] = false;
        }
        this.setState({ Employee: value }, () => {
          this.setState({ employeeFormData: {} }, () => {
            console.log(employeeFormData);
            this.setState({ employeeFormData: employeeFormData });
          });
        });
      }
    } else {
    }
  };

  render() {
    return (
      <React.Fragment>
        {/* {this.state.loader ? <Loader /> : null} */}
        <div className="setup-page-wrapper">
          {this.state.tabview ? (
            <React.Fragment>
              {/* <div className="invoice-page-wrapper new-table-wrap">
                <div className="trial-balance-header-title">
                  <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                    marginRight: '5px',
                    cursor: 'pointer',
                    marginTop: '0px'
                  }} />
                  <p className="top-header-title">| Leave Policy</p>
                </div> */}
              {this.state.containerNav == undefined ? null : (
                <React.Fragment>
                  <KenContainerNavbar
                    containerNav={this.state.containerNav}
                    onAddNew={this.onAddEmployees}
                  />
                  <div className="print-time">{this.state.printTime}</div>
                </React.Fragment>
              )}
              <div className="trial-balance-header-title">
                <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                  marginRight: '5px',
                  cursor: 'pointer',
                  marginTop: '0px'
                }} />
                <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Leave Policy</p>
              </div>
              <div className="table-wrapper" style={{ marginTop: "10px" }}>
                {this.state.employeeDetails.length == 0 ||
                  this.state.loader ? (
                  <p className="noprog-txt">{this.state.noProg}</p>
                ) : (
                  <React.Fragment>
                    <div className="remove-last-child-table">
                      <KenTable
                        data={this.state.employeeDetails}
                        rowClick={(item) => {
                          this.onPreviewLeaves(item);
                        }}
                      />
                    </div>
                  </React.Fragment>
                )}
                <div className="setup-pagination">
                  {this.state.employeeDetails.length !== 0 && (
                    <KenPaginationUI
                      onPaginationApi={this.onPaginationChange}
                      totalPages={this.state.totalPages}
                      limit={this.state.limit}
                      total={this.state.totalRecord}
                    />
                  )}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="tab-form-wrapper">
              <div className="goods-btns services-btns">
                <div className="preview-header-wrap">
                  <div className="trial-balance-header-title">
                    <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.handleBack() }} style={{
                      marginRight: '5px',
                      cursor: 'pointer',
                      marginTop: '0px'
                    }} />
                    {this.state.preview ?
                      <p className="top-header-title" onClick={() => { this.handleBack() }}>| Leave Policy | {this.state.leaveId}</p> :
                      <p className="top-header-title" onClick={() => { this.handleBack() }}>| Leave Policy | {this.state.addLeaveId}</p>}
                  </div>

                </div>

              </div>
              <div className="goods-wrapper service-wrapper form-heading-tab">

                <KenForm
                  formData={this.state.leavePolicyData}
                  className="goods-wrap"
                  onInputChanges={this.onInputChanges}
                  onFormBtnEvent={(item) => {
                    this.formBtnHandle(item);
                  }}
                  clear={true}
                  onSubmit={this.onSubmit}
                />

              </div>

            </div>

            // <div className="tab-form-wrapper tab-table ">
            //   <div className="trial-balance-header-title">
            //     <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={this.handleBack} style={{ marginRight: 5, cursor: 'pointer' }} />
            //     <p className="top-header-title">
            //       {this.state.preview ? (this.state.leaveID) : "| New Leave"}</p>
            //   </div>
            //   <ZenTabs
            //     tabData={this.state.employeeFormData}
            //     className="preview-wrap"
            //     form={this.state.employeeFormData}
            //     onFormBtnEvent={(item) => {
            //       this.formBtnHandle(item);
            //     }}
            //     onInputChanges={this.onInputChanges}
            //     onTabFormSubmit={this.onFormSubmit}
            //     handleTabChange={this.handleTabChange}
            //     clear={true}
            //   />
            // </div>



          )}
        </div>

        {/* {
          this.state.history ? (
            <Drawer show={this.state.showHistory} onHide={this.close}>
              <ZqHistory
                historyData={this.state.historyData}
                onCloseForm={this.onCloseForm}
              />
            </Drawer>
          ) : null
        } */}
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.snackBar}
          autoHideDuration={1000}
          message={this.state.processMessage}
          className="success-snackbar"

        />
      </React.Fragment >
    );
  }
}
export default withRouter(Leaves);